import ITextField from "../../shared/interfaces/text-field.interface";

export const TEXTFIELD: ITextField = {
	id: 'take-attendance',
    label: 'Número de documento',
    variant: 'standard',
    size:'small',
    showButton: true,
}